// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky[data-v-2902a874] {\n  position: sticky;\n  top: 16px;\n  z-index: 4;\n}", ""]);
// Exports
module.exports = exports;
